/**
 * Prefix for Jira "browse issue" links. Keep in sync with your Cloud site
 * (see Integrations / Jira connection). Prefer env-driven URL in the future if needed.
 */
export const JIRA_BROWSE_PREFIX = 'https://hrsinternational.atlassian.net/browse/';
